import SchemaForm from '@/components/broadcast/SchemaForm';

export default function ServicePreferenceForm({ schema, values, onChange }) {
  if (!schema?.length) {
    return (
      <p className="text-sm text-slate-500">No preference filters for this service.</p>
    );
  }
  return (
    <div className="space-y-2">
      <h4 className="font-semibold text-slate-900 text-sm">Your preferences</h4>
      <SchemaForm
        schema={schema}
        values={values}
        onChange={onChange}
        prefix="pref"
      />
    </div>
  );
}
